import React from "react";
import { Box } from "@mui/material";
import { IPolicyDetailsHeader, IPolicyVehicle } from "../../../models/user/policyDetails/PolicyDetails";
import PolicyDetailsHeaderStyles from "./PolicyDetailsHeaderStyles";
import BasicInfoCard from "./BasicInfoCard/BasicInfoCard";
import BasicInfoCardQuickActions from "./BasicInfoCardQuickActions/BasicInfoCardQuickActions";

interface IProps {
  data: IPolicyDetailsHeader | null;
  handlePayment: () => void;
  policyVehicles: IPolicyVehicle[];
}

const PolicyDetailsHeader: React.FC<IProps> = ({
  data,
  handlePayment,
  policyVehicles,
}: IProps) => {
  return (
    <Box
      id="policydetailsheader_container"
      data-test-id="test-policydetailsheader_container"
      aria-label="Policy Details Header Container"
      sx={PolicyDetailsHeaderStyles.BasicInfoCard}
    >
      <BasicInfoCard data={data} />
      <BasicInfoCardQuickActions
        handlePayment={handlePayment}
        carrierPolicyNumber={data?.carrierPolicyNumber || ""}
        policyVehicles={policyVehicles}
      />
    </Box>
  );
};

export default PolicyDetailsHeader;
